type ClassValue = string | false | null | undefined;

/** Joins truthy class names. Tiny replacement for `clsx` – keeps the package dependency-free. */
export const cx = (...values: ClassValue[]): string => {
  return values.filter(Boolean).join(' ');
};
